(() => {
  const initLanding = (root) => {
    if (!root || root.dataset.rzReady === 'true') return;
    root.dataset.rzReady = 'true';

    const gallery = root.querySelector('[data-rz-gallery]');
    if (!gallery) return;

    const slides = [...gallery.querySelectorAll('[data-rz-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-rz-thumb]')];
    const count = gallery.querySelector('[data-rz-count]');
    let active = 0;

    const show = (next) => {
      active = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        slide.hidden = index !== active;
        slide.classList.toggle('is-active', index === active);
      });
      thumbs.forEach((thumb, index) => {
        thumb.classList.toggle('active', index === active);
        thumb.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
      if (count) count.textContent = `${active + 1} / ${slides.length}`;
      if (gallery.dataset.rzInteracted === 'true') {
        thumbs[active]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    gallery.querySelector('[data-rz-prev]')?.addEventListener('click', () => { gallery.dataset.rzInteracted = 'true'; show(active - 1); });
    gallery.querySelector('[data-rz-next]')?.addEventListener('click', () => { gallery.dataset.rzInteracted = 'true'; show(active + 1); });
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => { gallery.dataset.rzInteracted = 'true'; show(Number(thumb.dataset.rzThumb)); }));

    let touchStart = 0;
    gallery.addEventListener('touchstart', (event) => {
      touchStart = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      const distance = (event.changedTouches[0]?.clientX || 0) - touchStart;
      if (Math.abs(distance) > 45) {
        gallery.dataset.rzInteracted = 'true';
        show(active + (distance < 0 ? 1 : -1));
      }
    }, { passive: true });

    show(0);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-rz-landing]').forEach(initLanding);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
